/*
 * COLECCIONES EN PESTAÑAS (POLAROID)
 * ---------------------------------------------------------------------------------------------------------------------
 * El guion de sections/collection-tabs-polaroid.liquid. Dos cosas, y las dos sobre la misma sensación: que la sección
 * va lenta.
 *
 *   1. ABRIR EL <template> DE UNA PESTAÑA. Los productos de todas las pestañas viajan en el HTML, pero solo los de la
 *      primera se entregan como HTML vivo: los demás van dentro de un <template>, que el navegador lee y guarda sin
 *      construir nada. Aquí se abren en cuanto el cursor toca el botón de esa pestaña —antes del clic, mientras el
 *      dedo o el ratón todavía se acercan— y también dentro de la propia transición, que es el camino que queda para
 *      el teclado y para el editor.
 *
 *   2. QUITAR LA ANIMACIÓN DE <x-tabs>. La que trae el tema encadena tres tramos —el panel viejo se va (0,3 s), la
 *      altura se estira hasta la del nuevo (0,15 s) y el nuevo entra con otra décima de espera (0,3 s)—: cerca de
 *      nueve décimas desde el clic hasta poder mirar. Para una fila de fotos que ya está en el HTML, esos tres tramos
 *      son la lentitud entera. Se sustituye por el cambio inmediato y una entrada de 120 ms.
 *
 *      Se reemplaza el método en ESE elemento, no en la clase: <x-tabs> sigue funcionando igual en el resto del tema.
 *      Y se puede hacer antes de que theme.js llegue, porque una propiedad propia escrita sobre un elemento aún sin
 *      definir sobrevive a su arranque y tapa a la del prototipo.
 *
 * Vive en un asset y no en un <script> dentro de la sección porque la sección está en la portada: así el navegador lo
 * descarga y lo cachea una vez, en lugar de traerse las mismas ochenta y seis líneas con cada visita. El CSS que lo
 * acompaña está en el bloque "PERSONALIZACIONES SANDMADE" de theme.css.
 */
(function () {
  var SELECTOR = 'x-tabs.polaroid-tabs';
  var arrancadas = new WeakSet();

  function arrancar(tabs) {
    if (arrancadas.has(tabs)) return;
    arrancadas.add(tabs);

    var root = tabs.closest('.shopify-section') || tabs;
    var engaged = false;

    function panels() {
      return tabs.querySelectorAll('.polaroid-tabs__panel');
    }

    /* 1. Abrir la pestaña guardada. El ":scope >" importa: el <template> de la pestaña es hijo directo del panel, y
       dentro de las tarjetas hay otros (los de las segundas fotos) que no son asunto suyo. */
    function revealPanel(panel) {
      var template = panel && panel.querySelector(':scope > template');
      if (template) template.replaceWith(template.content);
      if (engaged) revealHoverImages(panel);
    }

    function panelAt(index) {
      return panels()[index];
    }

    /* 2. Sacar las segundas fotos de su <template> y meterlas en el enlace de cada tarjeta, que es donde el CSS del
       tema las busca. A partir de ahí el cambio al pasar el cursor es el del tema, sin más. */
    function revealHoverImages(scope) {
      if (!scope) return;
      var stored = scope.querySelectorAll('.polaroid > template[data-hover-image]');
      for (var i = 0; i < stored.length; i++) {
        var media = stored[i].parentElement.querySelector('.product-card__media');
        if (media) media.appendChild(stored[i].content);
        stored[i].remove();
      }
    }

    /* El cursor entrando en la sección es la señal: alguien está mirando esto y puede que se acerque a una foto.
       Llega antes que el primer hover sobre una tarjeta —hay que cruzar el título y las pestañas—, así que da tiempo
       a que la imagen esté descargada cuando de verdad se la pida. En un teléfono no ocurre nunca, y ahí esas fotos
       no se ven de todos modos. */
    root.addEventListener('pointerover', function () {
      engaged = true;
      var list = panels();
      for (var i = 0; i < list.length; i++) revealHoverImages(list[i]);
    }, { passive: true, once: true });

    /* 3. Adelantar la apertura de una pestaña al momento de apuntar a su botón, antes del clic. */
    tabs.addEventListener('pointerover', function (event) {
      var button = event.target.closest && event.target.closest('button[role="tab"]');
      if (!button) return;
      revealPanel(panelAt([].indexOf.call(tabs.querySelectorAll('button[role="tab"]'), button)));
    }, { passive: true });

    /* 4. El cambio de pestaña, sin la animación encadenada del tema. */
    tabs.transition = function (fromPanel, toPanel) {
      revealPanel(toPanel);
      if (fromPanel) fromPanel.hidden = true;
      if (toPanel) {
        toPanel.hidden = false;
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          toPanel.animate({ opacity: [0, 1] }, { duration: 120, easing: 'ease-out' });
        }
      }
      return Promise.resolve();
    };

    /* 5. Mientras la página se desplaza, la rejilla no atiende al cursor.

       Bajar la página con el ratón encima de las fotos es lo que peor se sentía, y con razón: el cursor va cruzando
       una tarjeta tras otra sin que nadie se lo pida, y cada cruce enciende el hover entero —el marco que se endereza
       y se levanta, la sombra marcada que aparece, la segunda foto que se funde—. Son tres animaciones por tarjeta,
       arrancando y cancelándose a la velocidad a la que rueda la rueda.

       Congelar los paneles mientras se desplaza cuesta dos cambios de estilo por gesto y ahorra todo eso. Se
       descongelan 100 ms después de la última sacudida, que es antes de que a nadie le dé tiempo a apuntar. Solo
       donde hay ratón —en una pantalla táctil no hay hover que congelar— y solo mientras la sección anda cerca, para
       no escuchar el desplazamiento de las otras once. */
    if (matchMedia('(hover: hover)').matches) {
      var thaw = 0;

      var onScroll = function () {
        if (!thaw) tabs.classList.add('polaroid-tabs--frozen');
        clearTimeout(thaw);
        thaw = setTimeout(function () {
          thaw = 0;
          tabs.classList.remove('polaroid-tabs--frozen');
        }, 100);
      };

      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          addEventListener('scroll', onScroll, { passive: true });
        } else {
          removeEventListener('scroll', onScroll);
          clearTimeout(thaw);
          thaw = 0;
          tabs.classList.remove('polaroid-tabs--frozen');
        }
      }, { rootMargin: '200px' }).observe(root);
    }
  }

  function arrancarDentro(scope) {
    var encontradas = (scope || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < encontradas.length; i++) arrancar(encontradas[i]);
  }

  arrancarDentro(document);

  /* En el editor, Shopify vuelve a pintar la sección entera: las pestañas que llegan son otras y hay que arrancarlas.
     El WeakSet se encarga de que las que ya estaban no se arranquen dos veces. */
  document.addEventListener('shopify:section:load', function (event) {
    arrancarDentro(event.target);
  });
})();
